import React from "react";
import styles from "../home-page-desktop.module.scss";
import stylesMobile from "../home-page-mobile.module.scss";
import { BenefitsList } from "@/elements-react/benefits-list";
import { CarBrandsList } from "@/elements-react/car-brands-list";
import { PageSectionLayout } from "@/elements-react/page-section-layout";
import { CategoriesPreviewCustom } from "@/elements-react/categories-preview-custom";
import { MainBanner } from "@/elements-react/main-banner";
import bannerMahle from "@/assets/banner_mahle.webp";
import bannerFebi from "@/assets/banner_febi.webp";
import bannerMahleLoggined from "@/assets/banner_mahle_loggined.webp";
import bannerFebiLoggined from "@/assets/banner_febi_loggined.webp";
import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { LayoutStyleTypes } from "@/util-react/layout";
import { useHomeCommon } from "@/pages-react/home-page/home-page-common";
import { Url } from "@/helpers/url";
import { googleEvent } from "@/helpers/google-events";

export const HomePageDefaultDesktop: React.FC = withCatalogLayout(() => {
  const { isLoggedIn, topLevelCategories } = useHomeCommon();

  const renderIsLoginBanner = () => (
    <div className={`${styles.container} ${styles.overflowHidden}`}>
      <div className={styles.loggined}>
        <div className={styles.bannerBlock}>
          <a href={Url.to("dynamic-route", { dynamicPath: ["mahle"] })} onClick={() => googleEvent("banner_click", "mahle")}>
            <img className={styles.bannerBlockImg} src={bannerMahleLoggined} alt="Mahle" />
          </a>
        </div>
        <div className={styles.bannerBlock}>
          <a href={Url.to("dynamic-route", { dynamicPath: ["febi"] })} onClick={() => googleEvent("banner_click", "febi")}>
            <img className={styles.bannerBlockImg} src={bannerFebiLoggined} alt="Febi" />
          </a>
        </div>
      </div>
    </div>
  );

  const renderNotLoginBanner = () => (
    <div className={`${styles.container} ${styles.overflowHidden}`}>
      <div className={styles.left}>
        <MainBanner type={LayoutStyleTypes.TYPE_LG} />
      </div>
      <div className={styles.right}>
        <div className={styles.top}>
          <a href={Url.to("dynamic-route", { dynamicPath: ["mahle"] })} onClick={() => googleEvent("banner_click", "mahle")}>
            <img src={bannerMahle} alt="Mahle" />
          </a>
        </div>
        <div className={styles.bottom}>
          <a href={Url.to("dynamic-route", { dynamicPath: ["febi"] })} onClick={() => googleEvent("banner_click", "febi")}>
            <img src={bannerFebi} alt="Febi" />
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`${styles.offsets} ${styles.offsetY}`}>
      <PageSectionLayout type={LayoutStyleTypes.TYPE_LG}>
        <CategoriesPreviewCustom type={LayoutStyleTypes.TYPE_LG} categories={topLevelCategories} />
      </PageSectionLayout>
      <CarBrandsList type={LayoutStyleTypes.TYPE_LG} />
      {isLoggedIn ? renderIsLoginBanner() : renderNotLoginBanner()}
      {/*<FeaturedBrandsList type={LayoutStyleTypes.TYPE_LG} />*/}
      <BenefitsList type={LayoutStyleTypes.TYPE_LG} />
    </div>
  );
});

export const HomePageDefaultMobile: React.FC = withCatalogLayout(() => {
  const { isLoggedIn, topLevelCategories } = useHomeCommon();

  return (
    <div className={stylesMobile.offsetY}>
      <PageSectionLayout type={LayoutStyleTypes.TYPE_SM}>
        <CategoriesPreviewCustom type={LayoutStyleTypes.TYPE_SM} categories={topLevelCategories} />
      </PageSectionLayout>
      {!isLoggedIn && <MainBanner type={LayoutStyleTypes.TYPE_SM} />}
      {/*<FeaturedBrandsList type={LayoutStyleTypes.TYPE_SM} />*/}
      <CarBrandsList type={LayoutStyleTypes.TYPE_SM} />
      <div className={stylesMobile.offsets}>
        <BenefitsList type={LayoutStyleTypes.TYPE_SM} />
      </div>
    </div>
  );
});
